import React from 'react';
import './HealthyUdder.css';

const steps = [
  {
    step: 1,
    title: "Healthy cows start with a clean routine",
    points: [
      "Regular milking hygiene and good barn conditions reduce infection risk.",
      "A clean environment is the first defense against mastitis.",
      "Daily care routines protect animal health and milk quality."
    ]
  },
  {
    step: 2,
    title: "Mastitis begins where bacteria break in",
    points: [
      "When bacteria enter the udder, they cause pain, inflammation, and a drop in milk quality.",
      "Poor hygiene during or after milking can introduce infection.",
      "Once inside, bacteria multiply fast — early care matters."
    ]
  },
  {
    step: 3,
    title: "Invisible infections, visible damage",
    points: [
      "Left untreated, mastitis can lead to permanent udder damage and major economic loss.",
      "Inflammation and swelling are clear signs of clinical mastitis. Subclinical mastitis may show no visible symptoms — but it’s still harmful.",
      "Infection affects both cow comfort and production."
    ]
  },
  {
    step: 4,
    title: "Mastitis costs more than milk",
    points: [
      "From discarded milk to high vet bills, the losses add up quickly.",
      "Chronic infections may lead to permanent udder damage.",
      "Each case of mastitis reduces milk yield and farmer profits."
    ]
  },
  {
    step: 5,
    title: "But the good news? It’s preventable with proper hygiene and care.",
    points: [
      "Pre- and post-milking teat disinfection lowers infection chances.",
      "Clean housing/ farm and regular health checks prevent bacterial buildup."
    ]
  },
  {
    step: 6,
    title: `"A few small steps today can protect your cows, milk, and profits tomorrow."`,
    points: [
      "Good prevention means better milk yield and animal comfort.",
      "Protecting livestock health protects your livelihood.",
      "Mastitis-free herds boost farm income and reputation."
    ]
  },
  {
    step: 7,
    title: `"Stop mastitis before it starts. Prevention is protection."`,
    points: [
      "Act early, treat properly, and prevent routinely.",
      "Don’t wait for symptoms — safeguard your herd now.",
      "Make prevention part of your everyday dairy practice."
    ]
  }
];

const HealthyUdder = () => {
  return (
    <section id="udder" className="udder-section">
      <div className="udder-container">
        <h2 className="section-title" data-aos="fade-up">A Healthy Udder. Happy Farmer</h2>
        <p className="section-subtitle" data-aos="fade-up">Mastitis may start small — but its impact is huge.</p>
        
        {steps.map((item, i) => (
          <div
            className={`udder-step ${i % 2 === 0 ? 'left' : 'right'}`}
            key={i}
            data-aos={i % 2 === 0 ? 'fade-right' : 'fade-left'}
          >
            <div className="circle">{item.step}</div>
            <div className="content-box">
              <h3>{item.title}</h3>
              <ul>
                {item.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HealthyUdder;
